const pandaConfig = {
    API_URL: process.env.REACT_APP_API_URL,
    GOOGLE_MAPS: process.env.REACT_APP_GOOGLE_MAPS,
    ENV: process.env.REACT_APP_ENV,
}

export default pandaConfig;